enum StatusTextEvents {
  /**
   * Dispatched when the a `StatusText` object has completed its error mode presentation.
   * 
   * Callback params:
   * 
   * `statusText`: `StatusText`. The affected status text object.
   */
  COMPLETE = 'complete',
}

export default StatusTextEvents;
